export const SET_VALID_TOKEN = "setValidToken";
export const SET_VALID_PHONE = "setValidPhone";
export const SET_VALID_OTP = "setValidOtp";
export const SET_USER_INFO = "setUserInfo";
export const SET_GAME = "setGame";
export const SET_GIFT_LIST = "setListGift";
export const SET_HISTORY = "setHistory";
export const SET_HISTORY_LOCATE = "setHistoryLocate";
export const SET_TOTAL_HISTORY = "setTotalHistory";
export const SET_DRAW_GAME = "setDrawGame";
export const SET_RETRY_GIFT = "setRetryGift";
export const SET_INSERT_ADDRESS = "setInsertAddress";
export const SET_CITY = "setCity";
export const SET_DISTRICT = "setDistrict";
export const SET_WARD = "setWard";
export const SET_SHOWING = "setShowing";
